import { Link } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function FounderSection() {
  return (
    <section data-testid="founder-section" className="py-24 md:py-32 bg-teh-bg">
      <div className="teh-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <p className="teh-overline">Leadership</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 text-teh-deep leading-[1.05] tracking-tight">
              A founder shaped
              <br />
              <span className="italic text-teh-green">by two decades</span>
              <br />
              of care.
            </h2>

            <div className="mt-10 flex items-start gap-5">
              <Quote className="w-8 h-8 text-teh-green shrink-0 mt-1" strokeWidth={1.5} />
              <blockquote className="font-serif text-2xl md:text-3xl text-teh-deep italic leading-snug">
                "We're not just building a business — we're building a healthcare enterprise
                that reflects the communities we serve."
              </blockquote>
            </div>

            <div className="mt-8 pl-13 flex items-center gap-4">
              <div className="h-px w-10 bg-teh-green" />
              <div>
                <p className="font-medium text-teh-deep">{COMPANY.founder}</p>
                <p className="text-sm text-teh-muted">{COMPANY.founderTitle}</p>
              </div>
            </div>

            <Link
              to="/about"
              data-testid="founder-cta"
              className="mt-10 inline-flex items-center gap-2 text-teh-navy font-medium hover:gap-3 hover:text-teh-green transition-all duration-300"
            >
              Read our story
              <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
            </Link>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-8 aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/29372724/pexels-photo-29372724.jpeg"
                  alt="Caregiver and senior adult"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="col-span-4 flex flex-col gap-4">
                <div className="aspect-square rounded-2xl bg-teh-navy text-white p-6 flex flex-col justify-between">
                  <p className="text-xs uppercase tracking-[0.22em] text-emerald-300">
                    Experience
                  </p>
                  <p className="font-serif text-4xl leading-none">
                    20+ <span className="text-base font-sans text-white/70">years</span>
                  </p>
                </div>
                <div className="aspect-square rounded-2xl bg-teh-surfaceAlt p-6 flex flex-col justify-between">
                  <p className="text-xs uppercase tracking-[0.22em] text-teh-green">
                    Founded
                  </p>
                  <p className="font-serif text-4xl text-teh-deep leading-none">
                    Georgia
                  </p>
                </div>
                <div className="flex-1 aspect-square rounded-2xl overflow-hidden">
                  <img
                    src="https://images.pexels.com/photos/8949908/pexels-photo-8949908.jpeg"
                    alt="Community caregivers"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
